export const desc = (column: string) => (a: any, b: any) => {
  if (a[column] === null) {
    return 1;
  } else if (b[column] === null) {
    return -1;
  }

  if (b[column] < a[column]) {
    return -1;
  }
  if (b[column] > a[column]) {
    return 1;
  }

  return 0;
};
